import Request from './request';
import Journal from './journal';
import { EventEmitter } from 'eventemitter3';

export default class Article {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new Article());
	}

	constructor() {
		this.events = new EventEmitter();
	}

	getArticles() {
		return Request.instance().get('/public/article', { journalId: Journal.instance().journalId() });
	}

	getArticlesMinimal(type) {
		return Request.instance().get(`/public/article/minimal/${type}`, { journalId: Journal.instance().journalId() });
	}

	getArticleById(articleId) {
		return Request.instance().get('/public/article/get/' + articleId);
	}

	getArticleByCode(articleCode) {
		return Request.instance().get('/public/article/code/' + articleCode);
	}

	getArticleResume(articleId) {
		return Request.instance().get('/public/article/resume/' + articleId);
	}

	getArticleResumeList(articleIdsList) {
		return Request.instance().post('/public/article/resume/list', articleIdsList);
	}

	getArticleTypes() {
		return Request.instance().get('/public/types/list');
	}

	editArticle(article) {
		if (!article.journalId) {
			article.journalId = Journal.instance().journalId();
		}
		return Request.instance().post('/article/create', article);
	}

	deleteArticle(id) {
		return Request.instance().delete('/article/delete/' + id);
	}

	searchArticle(search) {
		search.journalId = Journal.instance().journalId();
		return Request.instance().post(`/public/article/${search.page}/${search.size}`, search.filter);
	}

	getIndexArticles() {
		return Request.instance().get('/public/article/index', { journalId: Journal.instance().journalId() });
	}

}